import gql from 'graphql-tag';

const PersonalAccMain = {
  myNotificationsList: gql`
    query myNotificationsList($parameters: NotificationInput!) {
      myNotificationsList(parameters: $parameters) {
        itemsTotal
        itemsLeft
        itemsList {
          id
          title
          date
          type
          message
          is_checked
          link
        }
        elementsPerPage
      }
    }
  `,
  notCheckedNotificationsAmount: gql`
    query notCheckedNotificationsAmount {
      notCheckedNotificationsAmount
    }
  `,
  subscribeToPushNotifications: gql`
    mutation subscribeToPushNotifications($token: String!, $cartToken: String) {
      subscribeToPushNotifications(token: $token, cartToken: $cartToken) {
        token
      }
    }
  `
};

export default PersonalAccMain;
